import React from 'react';
import { Breadcrumbs } from 'components/breadcrumbs/Breadcrumbs';
import { Loading } from 'components/loading/Loading';
import { Menu } from 'components/menu/Menu';
import { useAppSelector } from 'ducks/hooks';
import { selectSettings } from 'ducks/settings/selectors';
import { PrivateTemplateQuery } from 'ducks/types/query-types';
import { selectAuthenticate } from 'ducks/user/selectors';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { Modals } from 'modals';
import { shallowEqual } from 'react-redux';
import { Outlet } from 'react-router';
import { Navigate, useLocation } from 'react-router-dom';
import { AutoSizer } from 'react-virtualized';
import { routes } from 'routes';
import { Notifications } from 'templates/components/Notifications';
import { Snackbar } from 'templates/components/Snackbar';
import { parseQueries } from 'utils/queries';

import cn from 'templates/Template.module.scss';

const { LOGIN } = routes;

export const PrivateTemplate = () => {
  const location = useLocation();
  const { refresh_timeout } = parseQueries<PrivateTemplateQuery>(location.search);
  const auth_check = useAppSelector(selectAuthenticate, shallowEqual);
  const settings = useAppSelector(selectSettings);

  const { theme } = useSwitchTheme();

  if (!auth_check) {
    return <Navigate to={LOGIN.path} state={{ referer: `${location.pathname}${location.search}` }} />;
  }

  const { loading, notification } = settings;
  return (
    <div className={cn.private}>
      <Menu />
      <div className={cn.content}>
        <Breadcrumbs />
        <div className={cn.scrollable} style={{ backgroundColor: theme.background }}>
          <AutoSizer>
            {({ height, width }) => (
              <div className={cn.scroll} style={{ height, width }}>
                <div className={cn.page}>
                  <Outlet />
                </div>
              </div>
            )}
          </AutoSizer>
        </div>
      </div>
      <Snackbar />
      <Modals />
      {notification && <Notifications message={notification} />}
      {loading && !refresh_timeout && <Loading variant="dark" />}
    </div>
  );
};
